export default [
    {
        path: 'material',
        component: () => import(
            /* webpackChunkName: 'cadastro-material' */
            '@/views/cadastro/material/Index'
        ),
        redirect: 'material/index',
        children: [
            {
                name: 'cadastro-material-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-material' */
                    '@/views/cadastro/material/List.vue'
                ),
            },
            {
                name: 'cadastro-material-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-material' */
                    '@/views/cadastro/material/Form.vue'
                ),
            },
            {
                name: 'cadastro-material-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-material' */
                    '@/views/cadastro/material/Form.vue'
                ),
            },
        ],
    },
]